import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Typography, Button, Card, Col, Row, Spin, Select, Modal } from "antd";
import { FilePdfOutlined } from "@ant-design/icons";
import * as taxCollectionActions from "../../../../actionCreators/TaxCollection";
import "./reports.css";
import { useParams, useHistory, Link } from "react-router-dom";
import BarChart from "../graph-plots/bar";
import {
  formatUnitsOfProperties,
  formatYearlyTotalAndPaidTax,
  customColorFunction,
  formatLabelFunction,
  tooltipFormatterFunction,
} from "../../../../utils/reportsUtils";

const CircleReport = ({
  getYearlyPaidAndTotalTaxOfCircle,
  yearlyTotalAndPaidTaxOfCircle,
  getYearlyPaidAndPendingUnitsOfCircle,
  yearlyPaidAndPendingUnitsOfCircle,
  getTotalRegisteredPropertiesOfCircle,
  totalRegisteredPropertiesOfCircle,
  getTaxOfCircle,
  taxOfCircle,
  getTopPaidUnitsOfCircle,
  topPaidUnitsOfCircle,
  getTopDefaultUnitsOfCircle,
  topDefaultUnitsOfCircle,
  getCircleOrZoneName,
  circleOrZoneName,
  user,
}) => {
  const isAdmin = (user) =>
    user?.currentUser?.data?.user_roles[0]?.role?.role === "Admin";
  const { id } = useParams();
  const history = useHistory();
  const [circle, setCircle] = useState(null);
  const [district, setDistrict] = useState(null);
  const [totalRegisterProperties, setTotalRegisteredProperties] =
    useState(null);
  const [totalTax, setTotalTax] = useState(null);
  const [pendingTax, setPendingTax] = useState(null);
  const [paidTax, setPaidTax] = useState(null);
  const [topPaidProperties, setTopPaidProperties] = useState(null);
  const [topDefaultProperties, setTopDefaultProperties] = useState(null);
  const [yearlyPaidAndPendingTaxData, setYearlyPaidAndPendingTaxData] =
    useState([]);
  const [yearlyPaidAndPendingUnits, setYearlyPaidAndPendingUnits] = useState(
    []
  );
  const [
    yearlyPaidAndPendingUnitsExpended,
    setYearlyPaidAndPendingUnitsExpended,
  ] = useState([]);

  const [
    yearlyPaidAndPendingTaxExpendedData,
    setYearlyPaidAndPendingTaxExpendedData,
  ] = useState([]);

  const [
    yearlyPaidAndPendingTaxModalVisible,
    setYearlyPaidAndPendingTaxModalVisible,
  ] = useState(false);
  const [
    yearlyPaidAndPendingUnitsModalVisible,
    setYearlyPaidAndPendingUnitsModalVisible,
  ] = useState(false);
  const [numberOfYearsSelected, setNumberOfYearsSelected] = useState(10);
  const [numberOfYearsSelectedUnitsModal, setNumberOfYearsSelectedUnitsModal] =
    useState(10);

  const onExpandButtonClick = (event) => {
    event.preventDefault();
    setYearlyPaidAndPendingTaxModalVisible(true);
  };
  useEffect(() => {
    getCircleOrZoneName({ circle_id: id });
    getYearlyPaidAndTotalTaxOfCircle({ circle_id: id });
    getYearlyPaidAndPendingUnitsOfCircle({ circle_id: id });
    getTotalRegisteredPropertiesOfCircle({ circle_id: id });
    getTaxOfCircle({ circle_id: id });
    getTopPaidUnitsOfCircle({ circle_id: id });
    getTopDefaultUnitsOfCircle({ circle_id: id });
  }, []);
  useEffect(() => {
    setCircle(circleOrZoneName?.data[0]?.circle);
    setDistrict(circleOrZoneName?.data[0]?.district);
  }, [circleOrZoneName.data]);
  useEffect(() => {
    const [data, initialData] = formatYearlyTotalAndPaidTax(
      yearlyTotalAndPaidTaxOfCircle.data,
      numberOfYearsSelected
    );
    setYearlyPaidAndPendingTaxExpendedData(data);
    setYearlyPaidAndPendingTaxData(initialData);
    const currentYearPendingTax = initialData[initialData?.length - 1]?.tax;
    setPendingTax(currentYearPendingTax);
    setTotalTax(initialData[initialData?.length - 2]?.tax);
  }, [yearlyTotalAndPaidTaxOfCircle.data]);
  useEffect(() => {
    const [data, initialData] = formatUnitsOfProperties(
      yearlyPaidAndPendingUnitsOfCircle.data,
      numberOfYearsSelected
    );
    setYearlyPaidAndPendingUnitsExpended(data);
    setYearlyPaidAndPendingUnits(initialData);
  }, [yearlyPaidAndPendingUnitsOfCircle.data]);
  useEffect(() => {
    setTotalRegisteredProperties(
      totalRegisteredPropertiesOfCircle?.data?.TotalProperties?.[0]?.total
    );
  }, [totalRegisteredPropertiesOfCircle.data]);
  useEffect(() => {
    setTotalTax(taxOfCircle?.data?.TaxByCircle[0]?.total);
    setPaidTax(taxOfCircle?.data?.TaxByCircle[0]?.paid);
  }, [taxOfCircle.data]);
  useEffect(() => {
    setTopPaidProperties(topPaidUnitsOfCircle?.data?.Properties);
  }, [topPaidUnitsOfCircle.data]);
  useEffect(() => {
    setTopDefaultProperties(topDefaultUnitsOfCircle?.data?.Properties);
  }, [topDefaultUnitsOfCircle.data]);

  const onUnitsExpandButtonClick = (event) => {
    event.preventDefault();
    setYearlyPaidAndPendingUnitsModalVisible(true);
  };

  useEffect(() => {
    const [newTaxDetails] = formatYearlyTotalAndPaidTax(
      yearlyTotalAndPaidTaxOfCircle.data,
      numberOfYearsSelected
    );
    setYearlyPaidAndPendingTaxExpendedData(newTaxDetails);
  }, [numberOfYearsSelected]);

  useEffect(() => {
    const [unitsData] = formatUnitsOfProperties(
      yearlyPaidAndPendingUnitsOfCircle.data,
      numberOfYearsSelectedUnitsModal
    );
    setYearlyPaidAndPendingUnitsExpended(unitsData);
  }, [numberOfYearsSelectedUnitsModal]);
  return (
    <div>
      <div className="header">
        <Typography className="heading report-heading">
          <Link to={isAdmin(user) ? "/admin/overview" : "/reports/overview"}>
            Reports Overview ({district ? district : "-"})
          </Link>
          <span className="sub-heading">
            {" "}
            / Circle: {circle ? circle : "-"}
          </span>
        </Typography>
        <div>
          <Button
            className="export-report-button"
            type="primary"
            icon={<FilePdfOutlined />}
            onClick={() => {
              history.push("/reports/circle-pdf/" + id);
            }}
          >
            EXPORT REPORT
          </Button>
        </div>
      </div>
      <div className="body">
        <Row Type="flex" gutter={[16, 16]}>
          <Col xs={24} sm={24} md={24} lg={12} xl={12}>
            <div className="report-stats">
              <div className="report-stats-container">
                <Typography className="report-stats-header">
                  Total Registered Properties current fiscal year
                </Typography>
                {totalRegisteredPropertiesOfCircle?.loading ? (
                  <div className="report-stats-data center-loader">
                    <Spin />{" "}
                  </div>
                ) : (
                  <div className="report-stats-data">
                    {totalRegisterProperties
                      ? parseInt(totalRegisterProperties)?.toLocaleString()
                      : 0}
                  </div>
                )}
              </div>
              <div style={{ height: "5px" }}></div>
              <div className="report-stats-container">
                <Typography className="report-stats-header">
                  Total Demand current fiscal year
                </Typography>
                {taxOfCircle?.loading ? (
                  <div className="report-stats-data center-loader">
                    <Spin />{" "}
                  </div>
                ) : (
                  <div className="report-stats-data">
                    PKR {totalTax ? parseInt(totalTax)?.toLocaleString() : 0}
                  </div>
                )}
              </div>
              <div style={{ height: "5px" }}></div>
              <div className="report-stats-container">
                <Typography className="report-stats-header">
                  Pending amount current fiscal Year
                </Typography>
                {taxOfCircle?.loading ? (
                  <div className="report-stats-data center-loader">
                    <Spin />{" "}
                  </div>
                ) : (
                  <div className="report-stats-data">
                    PKR{" "}
                    {pendingTax ? parseInt(pendingTax)?.toLocaleString() : 0}
                  </div>
                )}
              </div>
              <div style={{ height: "5px" }}></div>
              <div className="report-stats-container">
                <Typography className="report-stats-header">
                  Paid amount current fiscal Year
                </Typography>
                {taxOfCircle?.loading ? (
                  <div className="report-stats-data center-loader">
                    <Spin />{" "}
                  </div>
                ) : (
                  <div className="report-stats-data">
                    PKR {paidTax ? parseInt(paidTax)?.toLocaleString() : 0}
                  </div>
                )}
              </div>
            </div>
          </Col>
          <Col xs={24} sm={24} md={24} lg={12} xl={12}>
            <Card bordered={false} className="full-height-card">
              <Row>
                <Col xl={12}>
                  <Typography className="report-stats-header">
                    Yearly Tax Overview
                  </Typography>
                </Col>
                <Col xl={12}>
                  <div>
                    <Button
                      className="overlay-btn"
                      onClick={onExpandButtonClick}
                      disabled={!yearlyTotalAndPaidTaxOfCircle?.data?.length}
                    >
                      Expand
                    </Button>
                  </div>
                </Col>
              </Row>
              <BarChart
                loading={yearlyTotalAndPaidTaxOfCircle?.loading}
                data={yearlyPaidAndPendingTaxData}
                xField="year"
                yField="tax"
                xLabel="Fiscal Year"
                yLabel="Tax (PKR)"
                customColorFtn={customColorFunction}
                colorFieldName={"name"}
                formatLabelFunction={formatLabelFunction}
                tooltipFormatterFunction={tooltipFormatterFunction}
                isNoData={!yearlyTotalAndPaidTaxOfCircle?.data?.length}
              />
            </Card>
          </Col>
          <Col xs={24} sm={24} md={24} lg={24} xl={24}>
            <Card className="barchar-containing-car full-height-card ">
              <Row>
                <Col xl={12}>
                  <Typography className="report-stats-header">
                    Tax Units Overview
                  </Typography>
                </Col>
                <Col xl={12}>
                  <div>
                    <Button
                      className="overlay-btn"
                      onClick={onUnitsExpandButtonClick}
                      disabled={
                        !yearlyPaidAndPendingUnitsOfCircle?.data?.length
                      }
                    >
                      Expand
                    </Button>
                  </div>
                </Col>
              </Row>
              <BarChart
                data={yearlyPaidAndPendingUnits}
                loading={yearlyPaidAndPendingUnitsOfCircle?.loading}
                xField="year"
                yField="units"
                xLabel="Fiscal Year"
                yLabel="Units (Properties)"
                customColorFtn={customColorFunction}
                colorFieldName={"name"}
                formatLabelFunction={formatLabelFunction}
                isNoData={!yearlyPaidAndPendingUnitsOfCircle?.data?.length}
              />
            </Card>
          </Col>
        </Row>
        <Row className="second-row">
          <Col className="property-data-main-container" span={11}>
            <div className="property-data-header-container">
              <Typography>Top Paid Units</Typography>
            </div>
            {topPaidUnitsOfCircle?.loading ? (
              <div
                style={{
                  width: "100%",
                  height: "30vh",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Spin />
              </div>
            ) : topPaidProperties?.length === 0 ? (
              <div
                style={{
                  width: "100%",
                  height: "30vh",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                No Properties to show.
              </div>
            ) : (
              <>
                {topPaidProperties?.map((data, index) => {
                  return (
                    <div className="propeerty-data-container" key={index}>
                      <Typography>{data?.pin}</Typography>
                    </div>
                  );
                })}
              </>
            )}
          </Col>
          <Col className="property-data-main-container" span={12} offset={1}>
            <div className="property-data-header-container">
              <Typography>Top Pending Units</Typography>
            </div>
            {topDefaultUnitsOfCircle?.loading ? (
              <div
                style={{
                  width: "100%",
                  height: "30vh",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Spin />
              </div>
            ) : topDefaultProperties?.length === 0 ? (
              <div
                style={{
                  width: "100%",
                  height: "30vh",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                No Properties to show.
              </div>
            ) : (
              <>
                {topDefaultProperties?.map((data, index) => {
                  return (
                    <div className="propeerty-data-container" key={index}>
                      <Typography>{data?.pin}</Typography>
                      <Typography className="pending-tax">
                        Pending PKR {data?.current_year_tax}
                      </Typography>
                    </div>
                  );
                })}
              </>
            )}
          </Col>
        </Row>
      </div>
      <Modal
        title="Yearly Tax Overview"
        visible={yearlyPaidAndPendingTaxModalVisible}
        onOk={() => {
          setYearlyPaidAndPendingTaxModalVisible(false);
        }}
        onCancel={() => {
          setYearlyPaidAndPendingTaxModalVisible(false);
        }}
        width="60%"
        className="expanded-modal"
      >
        <div>
          <Row gutter={16}>
            <Col span={24}>
              <div style={{ display: "flex", flexDirection: "row-reverse" }}>
                <Select
                  defaultValue={numberOfYearsSelected}
                  onChange={(value) => {
                    setNumberOfYearsSelected(value);
                  }}
                >
                  <Select.Option value={10}>Last 10 years</Select.Option>
                  <Select.Option value={20}>Last 20 years</Select.Option>
                  <Select.Option value={30}>Last 30 years</Select.Option>
                </Select>
              </div>
              <BarChart
                data={yearlyPaidAndPendingTaxExpendedData}
                xField="year"
                yField="tax"
                customColorFtn={customColorFunction}
                colorFieldName={"name"}
                formatLabelFunction={formatLabelFunction}
                tooltipFormatterFunction={tooltipFormatterFunction}
              />
            </Col>
          </Row>
        </div>
      </Modal>
      <Modal
        title="Tax Units Overview"
        visible={yearlyPaidAndPendingUnitsModalVisible}
        onOk={() => {
          setYearlyPaidAndPendingUnitsModalVisible(false);
        }}
        onCancel={() => {
          setYearlyPaidAndPendingUnitsModalVisible(false);
        }}
        width="60%"
        className="expanded-modal"
      >
        <div>
          <Row gutter={16}>
            <Col span={24}>
              <div style={{ display: "flex", flexDirection: "row-reverse" }}>
                <Select
                  defaultValue={numberOfYearsSelectedUnitsModal}
                  onChange={(value) => {
                    setNumberOfYearsSelectedUnitsModal(value);
                  }}
                >
                  <Select.Option value={10}>Last 10 years</Select.Option>
                  <Select.Option value={20}>Last 20 years</Select.Option>
                  <Select.Option value={30}>Last 30 years</Select.Option>
                </Select>
              </div>
              <BarChart
                data={yearlyPaidAndPendingUnitsExpended}
                xField="year"
                yField="units"
                customColorFtn={customColorFunction}
                colorFieldName={"name"}
                formatLabelFunction={formatLabelFunction}
              />
            </Col>
          </Row>
        </div>
      </Modal>
    </div>
  );
};

const mapStateToProps = ({
  user: user,
  taxCollection: {
    yearlyTotalAndPaidTaxOfCircle,
    yearlyPaidAndPendingUnitsOfCircle,
    totalRegisteredPropertiesOfCircle,
    taxOfCircle,
    topPaidUnitsOfCircle,
    topDefaultUnitsOfCircle,
    circleOrZoneName,
  },
}) => ({
  yearlyTotalAndPaidTaxOfCircle,
  yearlyPaidAndPendingUnitsOfCircle,
  totalRegisteredPropertiesOfCircle,
  taxOfCircle,
  topPaidUnitsOfCircle,
  topDefaultUnitsOfCircle,
  circleOrZoneName,
});

const mapDispatchToProps = (dispatch) => ({
  getYearlyPaidAndTotalTaxOfCircle: bindActionCreators(
    taxCollectionActions.getYearlyTotalAndPaidTaxOfCircle,
    dispatch
  ),
  getYearlyPaidAndPendingUnitsOfCircle: bindActionCreators(
    taxCollectionActions.getYearlyPaidAndPendingUnitsOfCircle,
    dispatch
  ),
  getTotalRegisteredPropertiesOfCircle: bindActionCreators(
    taxCollectionActions.getTotalRegisteredPropertiesOfCircle,
    dispatch
  ),
  getTaxOfCircle: bindActionCreators(
    taxCollectionActions.getTaxOfCircle,
    dispatch
  ),
  getTopPaidUnitsOfCircle: bindActionCreators(
    taxCollectionActions.getTopPaidUnitsOfCircle,
    dispatch
  ),
  getTopDefaultUnitsOfCircle: bindActionCreators(
    taxCollectionActions.getTopDefaultUnitsOfCircle,
    dispatch
  ),
  getCircleOrZoneName: bindActionCreators(
    taxCollectionActions.getCircleOrZoneName,
    dispatch
  ),
});

CircleReport.propTypes = {
  getYearlyPaidAndTotalTaxOfCircle: PropTypes.func.isRequired,
  getYearlyPaidAndPendingUnitsOfCircle: PropTypes.func.isRequired,
  getTotalRegisteredPropertiesOfCircle: PropTypes.func.isRequired,
  getTaxOfCircle: PropTypes.func.isRequired,
  getTopPaidUnitsOfCircle: PropTypes.func.isRequired,
  getTopDefaultUnitsOfCircle: PropTypes.func.isRequired,
  getCircleOrZoneName: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(CircleReport);
